class CosProductRecommendations extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver(this.handleIntersection, {
      rootMargin: '100% 0px',
      threshold: 0
    });
    observer.observe(this);
  }

  isNetworkError(error) {
    if (!error) return false;
    const message = error.message || error.toString() || '';
    return (
      message.includes('Failed to fetch') ||
      message.includes('Unable to fetch') ||
      message.includes('NetworkError') ||
      message.includes('Network request failed') ||
      error.name === 'TypeError' && message.includes('fetch')
    );
  }

  async initSlider() {
    const slider = this.querySelector('.products-slider:not(.keen-loaded)');
    if (!slider) return;

    try {
      // Safer access to window.modules
      if (!window.modules || !window.modules['keen-slider']) {
        console.warn('keen-slider module not available');
        return;
      }

      const { default: KeenSlider, sliderArrows } = await import(window.modules['keen-slider']);  
      const settings = JSON.parse(
        slider.getAttribute('data-slider-settings')
      ) || {};
      settings.detailsChanged = (slider) => {
        if (!slider.options) return;
        if (slider.options.disabled) {
          slider.container.classList.remove('keen-loaded');
        } else {
          slider.container.classList.add('keen-loaded');
        }
      };
      settings.destroyed = (slider) => {
        slider.container.classList.remove('keen-loaded');
      };
  
      KeenSlider(slider, settings, [sliderArrows]);
    } catch (e) {
      // Don't report network errors to Bugsnag (environmental, not code bugs)
      if (this.isNetworkError(e)) {
        console.warn('Network error loading keen-slider:', e.message || e);
      } else {
        if (typeof Bugsnag !== 'undefined') Bugsnag.notify(e);
        console.warn('Error loading keen-slider:', e);
      }
    }
  }

  handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    const url = this.dataset.url;
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cos-product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          
          this.initSlider();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
}
customElements.define('cos-product-recommendations', CosProductRecommendations);